import { CmxRadioButtonComponent } from './cmx-radio.component';

export class CmxRadioChange {
    public source: CmxRadioButtonComponent;
    public value: any;
}
